import { useState } from 'react'
import { useModalRetrievePropertyStore } from '../../../store'
import { toast } from '@dd3tech/wiggui/Toast'
import { putRetrieveProperty } from '../../../services'

export const useModalRetrieveProperty = () => {
  const [isLoading, setIsLoading] = useState(false)
  const modalRetrieveProperty = useModalRetrievePropertyStore(
    (state) => state?.modalRetrieveProperty
  )

  const reset = useModalRetrievePropertyStore((state) => state?.reset)

  const onClose = () => {
    reset()
  }

  const handleRetrieveProperty = async () => {
    try {
      setIsLoading(true)
      const { isSuccess } = await putRetrieveProperty({
        propertyId: modalRetrieveProperty?.propertyId
      })

      if (isSuccess) {
        reset()
        modalRetrieveProperty?.onSuccess?.()
        toast({
          type: 'success',
          title: 'Propiedad recuperada con éxito'
        })
        return
      }
      toast({
        type: 'error',
        title: 'No se pudo recuperar la propiedad'
      })
    } catch (error) {
      console.log(error)
      toast({
        type: 'error',
        title: 'No se pudo recuperar la propiedad'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    handleRetrieveProperty,
    isLoading,
    modalRetrieveProperty,
    onClose
  }
}
